import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    TimeScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import { enUS, tr } from 'date-fns/locale';

ChartJS.register(
    LineElement,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    TimeScale,
    zoomPlugin
);

const PatientChart = ({ data, t, lang }: any) => {
    const localeObj = lang === 'en-US' ? enUS : tr;

    const chartData = {
        datasets: [
            {
                label: t('success'),
                data: data.map((item: any) => ({
                    x: new Date(item.dateWillBeDone),
                    y: item.successPercentage,
                })),
                borderColor: '#6383F4',
                backgroundColor: (ctx: any) => {
                    const { chartArea, ctx: c } = ctx.chart;
                    if (!chartArea) return 'rgba(99, 131, 244, 0.4)';
                    const grad = c.createLinearGradient(0, 0, 0, chartArea.bottom);
                    grad.addColorStop(0, 'rgba(99, 131, 244, 0.4)');
                    grad.addColorStop(1, 'rgba(99, 131, 244, 0.0)');
                    return grad;
                },
                tension: 0,
                fill: true,
                pointRadius: 3,
            },
            {
                label: t('completion'),
                data: data.map((item: any) => ({
                    x: new Date(item.dateWillBeDone),
                    y: item.completionPercentage,
                })),
                borderColor: '#E97389',
                backgroundColor: (ctx: any) => {
                    const { chartArea, ctx: c } = ctx.chart;
                    if (!chartArea) return 'rgba(233, 115, 137, 0.4)';
                    const grad = c.createLinearGradient(0, 0, 0, chartArea.bottom);
                    grad.addColorStop(0, 'rgba(233, 115, 137, 0.4)');
                    grad.addColorStop(1, 'rgba(233, 115, 137, 0.0)');
                    return grad;
                },
                tension: 0,
                fill: true,
                pointRadius: 3,
            },
        ],
    };


    const DAY_MS = 1000 * 60 * 60 * 24;
    const now = new Date().getTime();
    const minZoomOut = now - DAY_MS * 120;
    const maxZoomOut = now + DAY_MS * 15;  
    const minZoomIn = DAY_MS * 30;         

    const options: any = {
        locale: lang,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                align: 'end',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rectRounded',
                    padding: 16,
                    boxWidth: 16,
                    color: '#727A99',
                },
            },
            tooltip: { mode: 'index', intersect: false },
            zoom: {
                pan: { enabled: true, mode: 'x', modifierKey: 'ctrl' },
                zoom: {
                    wheel: { enabled: true },
                    pinch: { enabled: true },
                    mode: 'x',
                },
                limits: {
                    x: {
                        min: minZoomOut,
                        max: maxZoomOut,
                        minRange: minZoomIn,
                    },
                },
            },
        },
        scales: {
            x: {
                type: 'time',
                adapters: {
                    date: { locale: localeObj },
                },
                time: {
                    unit: 'day',
                    tooltipFormat: 'PP',
                    displayFormats: {
                        day: 'MMM dd',
                        week: 'MMM dd',
                        month: 'MMM yyyy',
                    },
                },
                ticks: { color: '#2D3967' },
            },
            y: {
                beginAtZero: true,
                max: 100,
                title: { display: true, text: `${t('percentage')}(%)` },
            },
        },
    };

    return (
        <div style={{ width: Math.max(data.length * 100, 1000), height: '100%' }}>
            <Line key={lang} data={chartData} options={options} />
        </div>
    );
};

export default PatientChart;
